<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";

  export default {
    name: "App",
    components: {
      Header,
      Footer,
    },
    metaInfo: function() {
      return {
        titleTemplate: `%s | Fingers Meet App Offical Website`,
        htmlAttrs: {
          lang: "en",
          amp: true,
        },
        meta: [
          {
            vmid: "description",
            name: "description",
            content:
              "Download Fingers Meet from iOS App Store and Google Play Store",
          },
        ],
      };
    },
    data: function() {
      return {};
    },
    methods: {},
  };
</script>

<style>
  @import "~css/app.css";
</style>
